import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { anchorFromHash } from './hash-route';

// The target section renders only after the page's data arrives, so callers
// pass `ready` and the scroll fires once the anchor is actually in the DOM.
export function useScrollToHash(ready: boolean): void {
  const { hash } = useLocation();

  useEffect(() => {
    if (!ready) {
      return;
    }

    const anchor = anchorFromHash(hash);
    if (!anchor) {
      return;
    }

    const target = document.getElementById(anchor);
    if (!target) {
      return;
    }

    target.scrollIntoView({ block: 'start' });
  }, [ready, hash]);
}
